import { render } from "./ModificadorDetalle.vue?vue&type=template&id=65e36e24&scoped=true"
import script from "./ModificadorDetalle.vue?vue&type=script&lang=js"
export * from "./ModificadorDetalle.vue?vue&type=script&lang=js"

import "./ModificadorDetalle.vue?vue&type=style&index=0&id=65e36e24&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e36e24"]])

export default __exports__